<template>
    <div>
        <CCol sm="12" class="bg-FAFAFA">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow class="p-2">
                    <CCol sm="9">
                        <CRow>
                            <CCol sm="12" md="6" lg="3" class="p-1">
                                <div class="custom-bg-gradient-red" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Annual Leave
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="12" md="6" lg="3" class="p-1">
                                <div class="custom-bg-gradient-blue-white" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Medical Leave
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="12" md="6" lg="3" class="p-1">
                                <div class="custom-bg-gradient-white-blue" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Paternity Leave
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                            <CCol sm="12" md="6" lg="3" class="p-1">
                                <div class="custom-bg-gradient-purple" style="width: 100%;color: #fff">
                                    <h3 class="custom-18px-600 text-white">
                                        Maternity Leave
                                    </h3>
                                    <p class="custom-32px-700 text-white">0</p>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">

                          
                            <vue-cal 
                            :events="leave"
      @event-click="onEventClick" 
      class="font-color-171717" 
      active-view="month" 
      :events-on-month-view="[true, 'short'][shortEventsOnMonthView * 1]"
      show-all-events
      :views="['month']"
    />

      <!-- <vue-cal
  :disable-views="['years', 'year']"
  class="font-color-171717" 
  hide-weekends
  :show-all-day-events="['short', true, false][showAllDayEvents]"
  :events-on-month-view="[true, 'short'][shortEventsOnMonthView * 1]"
  :events="events">
</vue-cal> -->



    
    
                        </CRow>
                    </CCol>
                    <CCol sm="12" md="6" lg="3" class="p-0">
                        <div class="custom-input-app-form text-center">
                            <div v-if="dateError" class="text-danger mt-2">
                                {{ dateError }}
                            </div>
                            <CCol sm="12" class="text-left">
                                <h3 class="custom-18px-500 font-inter font-color-171717">Apply Leave</h3>
                                <p class="custom-14px-500 font-inter font-color-171717 mt-3"> Categories</p>
                                <v-select v-model="selectedLeave" :options="leaveOptions" label="Name"></v-select>
                                <CRow class="mt-3">
                                    <CCol sm="5">
                                        <label class="font-color-171717 font-inter custom-14px-500">Start</label>
                                    </CCol>
                                    <CCol sm="7">
                                        <label class="font-color-98A2B3 text-right">Full Day </label>
                                        <CSwitch class="float-right" size="sm" shape="pill" color="info" data-on="On" data-off="Off" />
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput type="date" v-model="startDateleave" @change="validateDates" :min="today" />
                                    </CCol>
                                </CRow>
    
                                <CRow class="mt-3">
                                    <CCol sm="5">
                                        <label class="font-color-171717 font-inter custom-14px-500">Finish</label>
                                    </CCol>
                                    <CCol sm="7">
                                        <label class="font-color-98A2B3 text-right">Full Day </label>
                                        <CSwitch class="float-right" size="sm" shape="pill" color="info" data-on="On" data-off="Off" v-model="isFullDay" />
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput type="date" v-model="endDateleave" @change="validateDates" :min="startDateleave || today" />
                                    </CCol>
                                </CRow>
    
                                <CRow class="mt-3">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">What is/are your reasson?</label>
                                        <CTextarea rows="4" placeholder="Please specify your reason..." v-model="reason"></CTextarea>
                                    </CCol>
                                </CRow>
    
                                <CRow class="mt-3">
                                    <CCol sm="12">
                                        <label class="font-color-171717 font-inter custom-14px-500">Supporting Document</label>
                                        <CCard>
                                            <div class="text-center p-1">
                                                <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                                <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                                <p class="font-color-0B63F6 m-0" @click="triggerFileInput">Click to upload</p>
                                                <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                                <!-- Display the file name if an image is not uploaded -->
                                                <p v-if="fileName" class="mt-2">{{ fileName }}</p>
                                            </div>
                                        </CCard>
                                    </CCol>
                                </CRow>
    
                                <CButton type="submit" @click="SubmitLeave" class="btn-success bg-0B63F6 border-20" block>Apply Leave</CButton>
                            </CCol>
    
    
                        </div>
                    </CCol>
    
                </CRow>
    
    
            </CCol>
    
            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Your leave request has been submitted successfully.
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal,
        FullCalendar

    },

    data() {
        return {
            leaveOptions: [],
            events: [
        {
          id: 1,
          start: "2024-08-30",
          end: "2024-08-30",
          title: "Nurul Leave",
          description: "Annual leave"
        },
        {
          id: 2,
          start: "2024-08-30",
          end: "2024-08-30",
          title: "Nadia Leave",
          description: "Annual leave"
        },
      ],

            startDate: new Date(),
            defaultView: 'month', // Default view to month,

            //form leave
            startDateleave: "",
            endDateleave: "",
            reason: "",
            selectedLeave: "",
            filePath: '',
            filePreview: null, // To hold the file preview URL
            fileName: null, // To hold the file name if not an image
            isFullDay: false,
            dateError: false,
            user: {},
            today: new Date().toISOString().split('T')[0],

            isPopupSuccess: false,
            selectedEvent: null,
            shortEventsOnMonthView: true,
            leave: []

        }





    },
    async mounted() {
       
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.getTypeLeave();
                this.GetListLeave();

            } else {
                this.GoToPage();

            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {
    

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        onDayClick(date) {
            console.log('Date clicked:', date);
            this.startDateleave = date;
            // Handle day click event
        },
        setCalendarView() {
            const vueCal = this.$refs.vueCal;
            if (vueCal) {
                vueCal.setView(this.defaultView); // Set the calendar view to month
            }
        },
        async getTypeLeave() {
            try {
                const response = await this.$API.get(this.$GetListTypeOfLeave);
                if (response.status === 200) {
                    this.leaveOptions = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        SubmitLeave() {
            const formData = new FormData();

            formData.append("leave_type_id", this.selectedLeave.Id);
            formData.append("start_date_leave", this.startDateleave);
            formData.append("end_date_leave", this.endDateleave);
            formData.append("leave_category_id", this.isFullDay ? 1 : 2);
            formData.append("reason", this.reason);


            this.$API
                .post(this.$ApplyLeave, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.idLeave = response.data;
                        this.submitFile(this.idLeave);
                        this.isPopupSuccess = true;


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            this.selectedFile = file; 
            if (file) {
                // Check if the uploaded file is an image
                if (file.type.startsWith('image/')) {
                    this.filePreview = URL.createObjectURL(file); // Create a URL for the image preview
                    this.fileName = null; // Clear the file name
                } else {
                    this.filePreview = null; // Clear the image preview
                    this.fileName = file.name; // Set the file name
                }
            }
        },
        async submitFile(id) {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('id', id);

                try {
                    const response = await this.$API
                        .post(this.$UploadDocFile, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                    console.log('Image uploaded successfully:', response.data);
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            } else {
                console.log('No file selected');
            }
        },
        validateDates() {
            this.dateError = null;

            if (this.startDateleave && this.endDateleave) {
                if (this.startDateleave < this.today || this.endDateleave < this.today) {
                    this.dateError = "Start and End dates must be today or later.";
                } else if (this.endDateleave < this.startDateleave) {
                    this.dateError = "End date cannot be before the start date.";
                }
            }
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            window.location.reload();
        },
        onEventClick(event) {
      this.selectedEvent = event;
    },
    async GetListLeave() {
            try {
                const response = await this.$API.get(this.$GetListEvent, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.leave = response.data;
                    console.log("leaveTableData", this.leaveTableData);
                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },



    }

};
</script>
<style scoped>
.vuecal__cell .count {
  display: none;
}
.vuecal--short-events .vuecal__event-title {
    text-align: left;
    overflow: hidden;
    white-space: break-spaces;
    /* text-overflow: ellipsis; */
    padding: 0 3px;
}
</style>